module.exports = __webpack_public_path__ + "img/login_bg.cd435fd5.png";